import { api } from "../../lib/api";
import { AssetStatsPropertyForFiltering, PropertiesForFiltering, RangeFilterType, StringFilterType } from "../../swagger/caasService-v1";
export const getProjectAssetTrendsDetails = async (projectId, startDate, assetId, frequency, fromDate, toDate, cursor) => {
    const filters = [];
    // Timestamp range filter — added when both fromDate and toDate are provided
    if (fromDate && toDate) {
        filters.push({
            propertyName: PropertiesForFiltering.TIMESTAMP,
            range: { includeLeft: true, includeRight: true, left: fromDate, right: toDate },
            type: RangeFilterType.TIME_RANGE
        });
    }
    // projectId filter
    filters.push({
        isCaseSensitive: true,
        propertyName: AssetStatsPropertyForFiltering.PROJECT_ID,
        type: StringFilterType.STRING_EQUALS,
        value: projectId
    });
    // assetId filter
    if (assetId) {
        filters.push({
            isCaseSensitive: true,
            propertyName: AssetStatsPropertyForFiltering.ASSET_ID,
            type: StringFilterType.STRING_EQUALS,
            value: assetId
        });
    }
    // aggregationType filter
    filters.push({
        isCaseSensitive: true,
        propertyName: AssetStatsPropertyForFiltering.AGGREGATION_TYPE,
        type: StringFilterType.STRING_EQUALS,
        value: "daily"
    });
    const requestBody = {
        filters,
        responseAttributes: ["assetId", "projectName", "projectId", "power", "soc", "timestamp"]
    };
    const { data } = await api.post(`/projects/${projectId}/assets/trends?startDate=${startDate}${frequency !== undefined ? `&frequency=${frequency}` : ""}${cursor ? `&cursor=${cursor}` : ""}`, requestBody);
    return {
        assetTrendsDetails: data.assetTrendsDetails,
        offset: data.offset,
        projectId: data.projectId,
        projectName: data.projectName,
        responseMetadata: data.responseMetadata,
        timezone: data.timezone
    };
};
